import { Outlet, createFileRoute } from "@tanstack/react-router"

export { default as StudySavedFlashcardsPage } from "./study.saved.index"

export const Route = createFileRoute("/_layout/study/saved")({
  component: StudySavedFlashcardsLayout,
})

function StudySavedFlashcardsLayout() {
  return (
    <div data-testid="saved-flashcards-outlet">
      <Outlet />
    </div>
  )
}

export default StudySavedFlashcardsLayout
